@let control = getControl();

<div class="textarea-control-wrapper">
  <htx-textarea-field
    [ctrl]="ctrl()"
    [label]="label()"
    [required]="required()">
  </htx-textarea-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="errorMessages()">
    </htx-error-field>
  }
</div>
